export default __webpack_public_path__ + "static/media/panel-text-and-shapes.cb6771ba.svg";